import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';

import "./techServicesSection.scss"
import { Link } from 'react-router-dom';
import iconoObjetibo from "../../../media/img/home/ObjetiboIcono.png"
import iconoCompromiso from "../../../media/img/home/CompromisoIcono.png"
import { FaBoxes, FaTools } from 'react-icons/fa';

const TechServicesSection = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    const servicesData = [
        {
            id: 1,
            icon: <FaBoxes size={50} color="#1e90ff" />,
            title: t("home.techServices.productsTitle"),
            description: t("home.techServices.productsDesc"),
            link: "products"
        },
        {
            id: 3,
            icon: <FaTools size={50} color="#1e90ff" />,
            title: t("home.techServices.servicesTitle"),
            description: t("home.techServices.servicesDesc"),
            link: "services"
        }
    ];

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });


        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);
    return (
        <div>
            <section className='section__services'>
                <div className='services__header'>
                    <h1 className='content__title-backgroundDark'>{t("home.techServices.title")}</h1>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line"
                    />
                    <h2 className='content__text-title-backgroundDark'>{t("home.techServices.subtitle")}</h2>
                </div>
                <div className="services__grid">
                    {servicesData.map((service) => (
                        <Link
                            to={`/productos/${service.link}`}
                            className="service-card__flip-container"
                            key={service.id}
                        >
                            <div className="service-card__flipper">
                                <div className="service-card__front">
                                    <div className="service-card__icon">
                                        {service.icon}
                                    </div>
                                    <div className="service-card__content">
                                        <h3 className="service-card__title">{service.title}</h3>
                                        <p className="service-card__description">{service.description}</p>
                                    </div>
                                </div>
                                <div className="service-card__back">
                                    <p className="service-card__back-text">{t("home.techServices.flipBack", { title: service.title })}</p>
                                    <p className="service-card__back-arrow"> &#8594; </p>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
                <div className="services__info-container">
                    <div className="services__info-block">
                        <div className="services__info-icon">
                            <img src={iconoObjetibo} alt="Icono compromiso" />
                        </div>
                        <div className="services__info-content">
                            <h3 className="services__info-title">{t("home.techServices.commitmentTitle")}</h3>
                            <p className="services__info-text">
                                {t("home.techServices.commitmentText")}
                            </p>
                        </div>
                    </div>

                    <div className="services__info-block">
                        <div className="services__info-icon">
                            <img src={iconoCompromiso} alt="Icono objetivos" />
                        </div>
                        <div className="services__info-content">
                            <h3 className="services__info-title">{t("home.techServices.goalsTitle")}</h3>
                            <p className="services__info-text">
                                {t("home.techServices.goalsText")}
                            </p>
                        </div>
                    </div>

                    <div className="services-info__block services-info__block--link">
                        <a href="/productos/products" className="services-info__link">
                            {t("home.techServices.knowMore")}
                        </a>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default TechServicesSection;

